import { runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ChecklistItemAnswerInDto } from 'shared/dtos/in/template';
import { checklistAnswerContract } from './checklistAnswerContract';
import type {
  ChecklistAnswerCreateModel,
  ChecklistAnswerDeleteModel,
  ChecklistAnswerEditModel,
} from './types/model';

/**
 * Checklist answers (an item's default answers) changed through the service
 * worker. Each change resolves once the server accepted it and rejects with its
 * error (`ChannelRequestError.messageId`); the template is synced afterwards.
 */
export const checklistAnswerClient = {
  /** Resolves with the created answer. */
  create(answer: ChecklistAnswerCreateModel): Promise<ChecklistItemAnswerInDto> {
    return runQueuedMutation(
      checklistAnswerContract,
      'create',
      (uniqueId) => ({ answer, uniqueId }),
      DomainMessagesTypes.checklistAnswerCreated
    );
  },

  /** Resolves with the saved answer. */
  edit(answer: ChecklistAnswerEditModel): Promise<ChecklistItemAnswerInDto> {
    return runQueuedMutation(
      checklistAnswerContract,
      'edit',
      (uniqueId) => ({ answer, uniqueId }),
      DomainMessagesTypes.checklistAnswerUpdated
    );
  },

  async remove(answer: ChecklistAnswerDeleteModel): Promise<void> {
    await runQueuedMutation(
      checklistAnswerContract,
      'remove',
      (uniqueId) => ({ answer, uniqueId }),
      DomainMessagesTypes.checklistAnswerDeleted
    );
  },
};
